import "./src/styles/globals.css"